import { render, staticRenderFns } from "./historique-analyse-biologique.html?vue&type=template&id=32013f28&scoped=true&external"
import script from "./historique-analyse-biologique.js?vue&type=script&lang=js&external"
export * from "./historique-analyse-biologique.js?vue&type=script&lang=js&external"
import style0 from "./historique-analyse-biologique.scss?vue&type=style&index=0&id=32013f28&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32013f28",
  null
  
)

export default component.exports